import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

// Helper function
const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

export const PromotionsColumns: ColumnDef<any>[] = [
	{
		accessorKey: "title",
		header: "Title",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 350,
		minSize: 250,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "code",
		header: "Code",
		size: 150,
		minSize: 100,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "active",
		header: "Active",
		size: 140,
		minSize: 100,
		cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
	},
	{
		accessorKey: "startDate",
		header: "Start Date",
		size: 250,
		minSize: 200,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "endDate",
		header: "End Date",
		size: 250,
		minSize: 200,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "discountPercent",
		header: "Discount Percent",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => `${(Number(getValue()) * 100).toFixed(2)}%`,
	},
	{
		accessorKey: "tags",
		header: "Tags",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => {
			const tags = getValue() as string[];
			return tags.length ? tags.join(", ") : "--";
		},
	},
	{
		accessorKey: "activeDays",
		header: "Active Days",
		size: 150,
		minSize: 100,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "allowUpdateDuringActivePeriod",
		header: "Allow Update During Active Period",
		size: 270,
		minSize: 220,
		cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];
